// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"xl","trailerHeader":"xm","trailers":"xn","trailer":"xo","imgWrapper":"xp","playWrapper":"xq","playImg":"xr","title":"xs","slipnslideArrow":"xt"};